/**
 * Bildgruppen je Variante (Anpassung dotSHOP, eigene Datei), Gegenstueck zu
 * snippets/custom-variantenbilder.liquid.
 *
 * Beim Variantenwechsel gleicht Dawn die grosse Galerie selbst mit der neu
 * geladenen Section ab, die Vorschaubilder darunter aber nicht. Dieses Skript
 * zeigt danach genau die Vorschaubilder, deren Bild in der Galerie steht,
 * und setzt Zaehler und Blaetterknoepfe der Slider neu.
 */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  if (window.customVariantenbilder) return;
  window.customVariantenbilder = true;

  function abgleichen(sectionId) {
    var galerie = document.getElementById('Slider-Gallery-' + sectionId);
    var vorschau = document.getElementById('Slider-Thumbnails-' + sectionId);
    if (!galerie) return;

    if (vorschau) {
      var sichtbar = {};
      galerie.querySelectorAll('li[data-media-id]').forEach(function (li) {
        sichtbar[li.dataset.mediaId] = true;
      });
      vorschau.querySelectorAll('li[data-target]').forEach(function (li) {
        // Dawn blendet Vorschaubilder mit dieser Klasse aus (ausser dem ersten)
        li.classList.toggle('thumbnail-list_item--variant', !sichtbar[li.dataset.target]);
        li.hidden = !sichtbar[li.dataset.target];
      });
    }

    ['GalleryViewer-' + sectionId, 'GalleryThumbnails-' + sectionId].forEach(function (id) {
      var slider = document.getElementById(id);
      if (slider && typeof slider.resetPages === 'function') slider.resetPages();
    });
  }

  subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
    var sectionId = ev && ev.data && ev.data.sectionId;
    if (sectionId) abgleichen(sectionId);
  });
})();
